<div class="family-bar" (click)="$event.stopPropagation()">
  <div class="family-bar__copy">
    <span class="family-bar__label">{{ 'app.parentFamily.contextLabel' | translate }}</span>
    @if (isNeutralScope()) {
      <span class="family-bar__hint">{{ 'app.parentFamily.scopeNeutralHint' | translate }}</span>
    } @else if (selectedChild()) {
      <span class="family-bar__hint">{{ 'app.parentFamily.scopeKidHint' | translate }}</span>
    } @else {
      <span class="family-bar__hint family-bar__hint--muted">
        {{ 'app.components.parentAiAssistant.selectChild' | translate }}
      </span>
    }
  </div>

  <div class="family-bar__selector">
    <button
      type="button"
      class="family-bar__trigger"
      [class.family-bar__trigger--open]="showChildSelector()"
      [class.family-bar__trigger--locked]="lockKidScope()"
      [disabled]="lockKidScope()"
      [attr.aria-expanded]="showChildSelector()"
      (click)="toggleChildSelector($event)"
    >
      @if (selectedChild(); as child) {
        @if (child.avatarUrl) {
          <img class="family-bar__avatar" [src]="child.avatarUrl" [alt]="child.name" />
        } @else {
          <span class="family-bar__avatar family-bar__avatar--initials">
            {{ avatarFallback(child) }}
          </span>
        }
        <span class="family-bar__name">{{ childContextLabel(child) }}</span>
      } @else {
        <span class="family-bar__avatar family-bar__avatar--neutral" aria-hidden="true">✨</span>
        <span class="family-bar__name">
          {{ 'app.parentFamily.neutralScope' | translate }}
        </span>
      }
      <span class="family-bar__arrow" aria-hidden="true">▼</span>
    </button>

    @if (showChildSelector()) {
      <app-parent-ai-child-dropdown
        [children]="children()"
        [selectedChildId]="selectedChildId()"
        (selectChild)="selectChild($event)"
        (selectNeutral)="selectNeutral()"
      />
    }
  </div>
</div>
